import React, {useState, useEffect} from 'react'
import './EditCensorModal.css'
import apiClient from '../api/apiClient'

export default function CreateStudentClassModal({schoolID, onCreate, onClose}){
    const [teachers, setTeachers] = useState([])

    const [formData, setFormData] = useState(
        {
            sprogcenter_id: schoolID,
            underviser_id: null,
            holdNavn: '', 
            interntHoldNummer: '',
            studieRetning: '',
            modul: '',
            startDato: '',
            slutDato: ''
        }
    )

    function handleSubmit(e){
        e.preventDefault()
        onCreate(formData)
    }

    async function fetchTeachers(){
        try{
            const result = await apiClient.get('/api/studentclass/getteachers', {
                params: {schoolID: schoolID}
                })
            setTeachers(result.data)
        }catch(e){
            console.log("get teachser from " + schoolID)
            console.log(e)
        }
    }

    useEffect(()=>{
        fetchTeachers()
    }, [])

    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">Opret hold</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-form-grid">
                        <div className="form-group">
                            <label>Hold navn:</label>
                            <input type="text" value={formData.holdNavn} 
                            onChange={(e)=>setFormData({...formData, holdNavn: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Internt holdnummer:</label>
                            <input type="text" value={formData.interntHoldNummer}
                            onChange={(e)=>setFormData({...formData, interntHoldNummer: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Studieretning</label>
                            <select value={formData.studieRetning} onChange={(e)=>{setFormData({...formData, studieRetning:e.target.value})}}>
                                <option key="DU1">DU1</option>
                                <option key="DU2">DU2</option>
                                <option key="DU3">DU3</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Modul:</label>
                            <input type="text" value={formData.modul}
                            onChange={(e)=>setFormData({...formData,modul:e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Start dato:</label>
                            <input type="date" value={formData.startDato}
                            onChange={(e)=> setFormData({...formData,startDato: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Slut dato:</label>
                            <input type="date" value={formData.slutDato}
                            onChange={(e)=>setFormData({...formData, slutDato: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <select onChange={(e) => setFormData({...formData, underviser_id: parseInt(e.target.value)})}>
                                <option key="0" value="0">Ingen underviser</option>
                                {
                                    teachers.map(teacher =>(
                                        <option key={teacher.id} value={teacher.id}>{teacher.fornavn} {teacher.efternavn}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="modal-actions" style={{marginTop: '20px'}}>
                        <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
                        <button type="submit" className="btn-save">Opret hold</button>
                    </div>
                </form>
            </div>
        </div>

    )
}